import styled, { css } from 'styled-components'
import Theme from '../../utils/theme'

declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}

interface CardProps {
  level?: number
  backgroundColor?: string
}

const CardStyles = css<CardProps>`
  display: flex;
  flex-direction: column;
  padding: ${({ theme, level = 1 }) => theme.padding(level)};
  margin-bottom: ${({ theme, level = 1 }) => theme.padding(level)};
  box-shadow: ${({ theme, level = 1 }) => theme.shadow(level)};
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ backgroundColor = '#fff' }) => backgroundColor};
  color: ${({ theme }) => theme.colors.darkText};
`

const Card = styled.div<CardProps>`
  ${CardStyles}
`

export const ArticleCard = styled.article<CardProps>`
  ${CardStyles}
`

export const NewArticleCard = styled.article<CardProps>`
  ${CardStyles}
  border: 1px solid #e0e5eb;
  border-radius: 8px;
  margin-bottom: 0;
`

export const ClickableCard = styled.a<CardProps>`
  ${CardStyles}

  transition: box-shadow 200ms ease;
  cursor: pointer;

  &:hover {
    box-shadow: ${({ theme, level = 1 }) => theme.shadow(level + 1)};
  }
`

export default Card

export const CardTitle = styled.h2`
  font-size: 1.3rem;
  font-weight: bold;
  padding: 0;
  margin: 0;
  color: inherit;
`
export const CardSubTitle = styled.h2`
  font-size: 0.9rem;
  font-weight: normal;
  padding: 0;
  margin: 0;
  color: inherit;
  opacity: 0.9;
`
